import React, { useState, useCallback } from 'react';
import DrawerBody from 'components/ui/DrawerBody';
import DrawerHeader from 'components/ui/DrawerHeader';
import DrawerFooter from 'components/ui/DrawerFooter';
import AssistanceRequestForm from './AssistanceRequestForm';
import CtaPrimary from 'components/ui/CtaPrimary';

import errorAnimationData from 'assets/error.json';
import loadingAnimationData from 'assets/loading.json';
import successAnimationData from 'assets/success.json';

import { getTranslatedString } from 'helpers/i18n';
import DrawerSuccessMessages from 'components/ui/DrawerSuccessMessages';
import Lottie from 'react-lottie';

const FORM_NAME = 'assistance_request_form';

const successAnimationOptiions = {
  loop: false,
  autoplay: true,
  animationData: successAnimationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const errorAnimationOptions = {
  loop: false,
  autoplay: true,
  animationData: errorAnimationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const loadingAnimationOptions = {
  loop: true,
  autoplay: true,
  animationData: loadingAnimationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const AssistancRequestDrawerWizard = ({ cotenantId, assistanceRequst, requiresAssistance, handleClose, getTenant }) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleLoadingChange = useCallback(options => {
    setError(options.isError);
    setLoading(options.isLoading);
  }, {});

  const handleSubmissionComplete = useCallback(formData => {
    setError(false);
    setLoading(false);
    setSuccess(true);
    getTenant(cotenantId);
  }, {});
  
  const successPage = (
    <DrawerSuccessMessages
      headerImageSource={<Lottie options={successAnimationOptiions} height={150} width={150} />}
      headerText={getTranslatedString('landlordPortal.residents.assistanceRequest.updateSuccess')}
      bodyText={getTranslatedString('globalDrawer.successBody')}
      cta={
        <CtaPrimary onClick={() => {setSuccess(false); handleClose()}}>
          {getTranslatedString('close')}
        </CtaPrimary>
      }
    />
  );
  const errorPage = (
    <DrawerSuccessMessages
      headerImageSource={<Lottie options={errorAnimationOptions} height={150} width={150} />}
      headerText={getTranslatedString('landlordPortal.residents.assistanceRequest.updateError')}
      bodyText={getTranslatedString('globalDrawer.errorBody')}
      cta={
        <CtaPrimary onClick={() => setError(false)}>
          {getTranslatedString('globalDrawer.goBack')}
        </CtaPrimary>
      }
    />
  );

  const loadingPage = (
    <DrawerSuccessMessages
      headerImageSource={<Lottie options={loadingAnimationOptions} height={150} width={150} />}
      headerText={getTranslatedString('landlordPortal.residents.assistanceRequest.updateLoading')}
      bodyText={getTranslatedString('globalDrawer.loadingBody')}
    />
  );

  const formPage = (
    <React.Fragment>
      <DrawerHeader
        onClose={handleClose}
        title={getTranslatedString('landlordPortal.residents.assistanceRequest.assistanceRequest')}
      />
      <DrawerBody>
        <AssistanceRequestForm
          cotenantId={cotenantId}
          formName={FORM_NAME}
          formData={{ assistance_request: assistanceRequst, requires_assistance: requiresAssistance }}
          onLoadingChange={handleLoadingChange}
          onSubmissionComplete={handleSubmissionComplete}
        />
      </DrawerBody>
      <DrawerFooter
        primaryActionFormName={FORM_NAME}
        primaryActionText={getTranslatedString('save')}
        primaryActionDisabled={loading}
      />
    </React.Fragment>
  );

  if (success) {
    return successPage;
  } else if (loading) {
    return loadingPage;
  } else if (error) {
    return errorPage;
  } else {
    return formPage;
  }
};

export default AssistancRequestDrawerWizard;
